// Shared layout breakpoints for the navigation + hero band.
// These widths are referenced from more than one file (the navbar, the search field, the
// dropdown card grid, the page container and the home hero all key off the same band), so
// they live here rather than being re-typed as literals at each call site.

/** Small-phone ceiling: the nav row, search trigger and footer all tighten below it. */
export const PHONE_MAX = 425;

/** Below this width the nav row has no room for a permanent search field. */
export const NAV_INLINE_SEARCH_MIN = 1350;

/** Above this width the dropdown cards show an extra link row before scrolling. */
export const NAV_CARD_WIDE_MIN = 1440;

/** Lower bound of the band where nav labels step down to 12px. */
export const NAV_COMPACT_MIN = 1023;

/** Upper bound (inclusive) of the narrow band shared by the nav labels and the hero copy. */
export const NARROW_LAYOUT_MAX = 1499;

/** Upper bound (inclusive) of the tighter band where the case-study tabs section needs an
 * extra size step down — the heading crowds the navbar and the tab rail/image get cramped. */
export const CASE_STUDY_TABS_TIGHT_MAX = 1300;

export const NAV_MID_LAYOUT_MIN = 1100;

export const NAV_DESKTOP_MIN = NAV_MID_LAYOUT_MIN;

/** Up to this width MUIContainer drops its max-width and runs edge to edge. */
export const CONTAINER_FULL_WIDTH_MAX = 1450;

/** The width at which MUIContainer switches its MUI maxWidth key from `lg` to `xl`. */
export const CONTAINER_XL_MIN = 1440;

// Raw conditions — for `useMediaQuery`, which takes the condition without the `@media`.
export const minWidthQuery = (px: number): string => `(min-width: ${px}px)`;
export const maxWidthQuery = (px: number): string => `(max-width: ${px}px)`;
export const betweenWidthQuery = (from: number, to: number): string => `(min-width: ${from}px) and (max-width: ${to}px)`;

// `@media`-prefixed — for use as `sx` object keys.
export const minWidth = (px: number): string => `@media ${minWidthQuery(px)}`;
export const maxWidth = (px: number): string => `@media ${maxWidthQuery(px)}`;
export const betweenWidth = (from: number, to: number): string => `@media ${betweenWidthQuery(from, to)}`;

/** Upper bound of the tight band where the dropdown gutter drops to 16px. */
export const NAV_TIGHT_LAYOUT_MAX = 1399;

/** Upper bound of the compact band where card labels step down to 12px. */
export const NAV_COMPACT_LAYOUT_MAX = 1279;

/** At/below this width the dropdown panel insets slightly instead of spanning full width. */
export const NAV_PANEL_INSET_MAX = 1024;

/** Ultra-wide widths where the dropdown's rail band takes a larger share of the panel. */
export const NAV_ULTRAWIDE_MIN = 2300;
export const NAV_ULTRAWIDE_XL_MIN = 3800;
